import localSagas from './sagas'
import localReducer from './reducer'

const module = {
  id: 'webinarAudienceRoom',
  reducerMap: {
    webinarAudienceRoom: localReducer,
  },
  sagas: localSagas,
}

export default module
